import styled from 'styled-components';
import { extractColor, colorType } from '../../helpers';

export default styled.div`
  font-size: 12px;
  color: ${extractColor(colorType.danger, 3)} !important;
`;
